import { render, staticRenderFns } from "./onlineTestQuestions.html?vue&type=template&id=aa61c934&external"
import script from "./onlineTestQuestions.vue?vue&type=script&lang=js"
export * from "./onlineTestQuestions.vue?vue&type=script&lang=js"
import style0 from "./onlineTestQuestions.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports